export class EstudioEmpresa {
    estudioId: number;

    constructor(
        public empresaId: number,
        public nombre: string,
        public parametros: string,
    ) { }
}